module.exports = __webpack_public_path__ + "assets/blood-cell.79dc018d.svg";